export const isInView = ({ scrollContainer, target, }) => {
    const { scrollWidth, scrollLeft, offsetWidth: visibleAreaWidth } = scrollContainer;
    const scrollRight = scrollWidth - (scrollLeft + visibleAreaWidth);
    const { offsetLeft, offsetWidth: targetWidth } = target;
    const offsetRight = scrollWidth - offsetLeft - targetWidth;
    if (scrollWidth === visibleAreaWidth)
        return true;
    return scrollLeft <= offsetLeft && scrollRight < offsetRight;
};
export const scrollToElement = ({ scrollContainer, target, }) => {
    scrollContainer.scrollLeft = target.offsetLeft + target.offsetWidth - scrollContainer.offsetWidth;
};
//# sourceMappingURL=horizontalScroll.js.map